import format from 'date-fns/format';

export const getFormattedBucketPrefix = (date: Date): string => {
  return format(date, 'yyyy-MM-dd-HH-mm-ss').toString();
};
